import { useCallback, useEffect, useState } from 'react'

interface PropsIn<T, I> {
  value: T
  formatter: (value: T) => I
  validator: (value: T) => boolean
}

export const useValidatedValue = <T, I>({ value, formatter, validator }: PropsIn<T, I>): I => {
  /* Set only valid values to state. Invalid values are
   * ignored so that last valid value is always in state.
   */

  const getValidatedValue = useCallback(
    (value, prevValue) => (validator(value) ? formatter(value) : prevValue),
    [validator, formatter]
  )
  const [state, setState] = useState<I>(getValidatedValue(value, undefined))
  useEffect(() => setState(prevState => getValidatedValue(value, prevState)), [value])

  return state
}
